import appConfig from '../../app.config'

export const KycConstants = {
	ApprovedIgnoredAttempts: getApprovedIgnoreAttemptsForCountry(),
}

function getApprovedIgnoreAttemptsForCountry() {
	switch (appConfig.country) {
		default:
			return 2
	}
}

export enum PurposeOfDeposit {
	Other,
	Investment,
	SavingForProperty,
	Renovation,
	PersonalEconomicSpace,
	NextInKin,
	Retirement,
	PrivateConsumption,
}

export enum MoneySource {
	Other,
	Income,
	Savings,
	OtherSavings,
	Investments,
	Inheritance,
	Gift,
	SalesOfProperty,
	SalesOfVehicle,
	SalesOfCulture,
	SaleOfCompany,
	Gambling,
	OtherBusiness,
	CapitalGains,
	InsuranceReimbursement,
	SocialInsuranceAllowance,
	Donation,
}

export enum DepositOwner {
	Unspecified,
	Other,
	Yes,
	YesGuardian,
	Children,
}

export enum OccupationType {
	Other,
	Permanent,
	PartTime,
	Entrepreneur,
	FixedTerm,
	Pensioner,
	Unemployed,
	Student,
	SickLeave,
	Retired,
	Housewife,
	TemporarilyEmployed,
	EmployedByHours,
	PublicServant,
	Farmer,
	Trainee,
	Manager,
}

export enum PurposeOfLoan {
	Unspecified,
	Consumption,
	DebtConsolidation,
	Renovation,
	HomeExpenses,
	Healthcare,
	Travel,
	PurchaseVehicle,
	Other,
	Gambling,
	Donation,
	RealEstatePurchase,
	Education,
	InvestmentInOwnCompany,
	Bills,
	PrivateInvestment,
	HomeHouseExpenses
}

export enum MissingKycValues {
	PurposeOfLoan = 'PurposeOfLoan',
	PEP = 'PEP',
	PurposeOfLoanOther = 'PurposeOfLoanOther',
	ConnectedToPep = 'ConnectedToPep',
}

export enum TaxCountry {
	No,
	Yes,
	YesOther,
}

export enum BenificialOwner {
	Yes,
	YesGuardian,
	NoOther,
}

export enum MaritalStatus {
	Unknown = 'Unknown',
	Single = 'Single',
	Married = 'Married',
	Divorced = 'Divorced',
	Widow = 'Widow',
	Cohabitee = 'Cohabitee',
}

export enum AccommodationType {
	Other = 'Other',
	Renter = 'Renter',
	Owner = 'Owner',
	PartOwner = 'PartOwner',
	WithParents = 'WithParents',
	Tenant = 'Tenant',
	PropertyOwnedByFamily = 'PropertyOwnedByFamily',
}

export enum Education {
	Unspecified = 'Unspecified',
	Basic = 'Basic',
	HighSchool = 'HighSchool',
	University = 'University',
	Other = 'Other',
	ProfessEducation = 'ProfessEducation',
}

export enum EmploymentSector {
	Other,
	Administration,
	Agriculture,
	Art,
	Gambling,
	Business,
	Culture,
	ConstructionRealEstate,
	EducationScience,
	Finance,
	Tourism,
	IndustryEnergy,
	PublicSector,
	Health,
	Security,
	Services,
	Technology,
	Technician,
	Transport,
	StallHolder,
	LegalOrJudicial,
}

export enum Gender {
	Unknown = 'Unknown',
	Male = 'Male',
	Female = 'Female',
}

export enum ChildrenAge {
	ZeroToTwo,
	ThreeToSix,
	SevenToTen,
	ElevenToFourteen,
	FifteenToSeventeen,
}

export enum PropertyType {
	Occupation = 'occupation',
	PurposeOfDeposit = 'purposeOfDeposit',
	MoneySource = 'moneySource',
	TaxCountry = 'taxCountry',
	ExpectedDeposits = 'expectedDeposits',
	ExpectedDepositsAmount = 'expectedDepositsAmount',
	ExpectedWithdrawls = 'expectedWithdrawals',
	ExpectedWithdrawlsAmount = 'expectedWithdrawalsAmount',
	Income = 'income',
	DepositOwner = 'depositOwner',
	PurposeOfLoan = 'purposeOfLoan',
	MaritalStatus = 'maritalStatus',
	AccommodationType = 'accommodationType',
	Education = 'education',
	EmploymentSector = 'employmentSector',
}